<div class="application-menu-wrapper" soho-busyindicator blockUI="true" displayDelay="-1">
  <div class="application-menu-header expandable-area-header" [ngClass]="{'lm-do-not-apply-color': !applyColorToMenu }">

    <svg *ngIf="noActorUrl()" class="icon avatar" viewBox="0 0 48 48" focusable="false" aria-hidden="true" role="presentation">
      <use xlink:href="#icon-user-avatar"></use>
    </svg>
    <img *ngIf="!noActorUrl()" class="icon avatar" [src]="actorUrl" alt=""/>
    <!-- decorative image, alt can be left blank since there's an actorName span below -->
    <ng-container *ngIf="(roleSwitcher && webAppMenuSpecs.length > 0) || (selectedMenuSpec && webAppMenuSpecs.length > noCasualApps)">
      <button type="button" class="btn application-menu-switcher-trigger expandable-area-trigger hide-focus" soho-tooltip title="{{ webAppTitle }}" id="{{webAppSwitcherButtonId}}">
        <span class="web-app-title">{{ webAppTitle }}</span>
        <svg class="icon icon-closed" focusable="false" aria-hidden="true" role="presentation">
          <use xlink:href="#icon-caret-down"></use>
        </svg>
        <svg class="icon icon-opened" focusable="false" aria-hidden="true" role="presentation">
          <use xlink:href="#icon-caret-up"></use>
        </svg>
      </button>
      <div class="expandable-area" aria-expanded="false" aria-controls="expandable-area-0-content" id="expandable-area-0-header">
        <div class="expandable-pane application-menu-switcher-panel" id="expandable-area-0-content" style="height: 0px; display: none;" attr.aria-label="{{'AppMenuSwitcherSection' | translate}}">
          <div class="content" style="height: 651.4px;">
            <div class="accordion panel inverse">
              <div *ngFor="let menuItem of webAppMenuSpecs" class="accordion-header hide-focus">
                <a href="#"
                   (click)="selectRole($event)"
                   (contextmenu)="onRoleRightClick($event, menuItem)"
                   attr.web-app-name="{{menuItem.webAppName}}"
                   attr.navigation-menu-url="{{menuItem?.navigationMenuUrl || menuItem?.link}}"
                   attr.id="{{webAppId(menuItem.webAppName)}}"
                   title="{{menuItem?.webAppTitle || menuItem?.name}}"
                ><span>{{menuItem?.webAppTitle || menuItem?.name}}</span></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <span class="name-xl">{{actorName}}</span>

    <div class="application-menu-toolbar">
      <div class="flex-toolbar">
        <div class="toolbar-section buttonset center-text">

          <ng-container *ngFor="let button of myMenuButtons" >
            <button *ngIf="button.url"
                    soho-button="icon"
                    id="{{button.id}}"
                    (click)="openLink(button.url)"
                    [icon]="button.icon"
                    soho-tooltip [content]="button.label"
            >
              {{ button.label }}
            </button>
            <span *ngIf="button.id === 'MyNotifications_button'" [ngClass]="{'red-dot' : displayRedDot }"></span>
          </ng-container>
          <ng-container *ngIf="showOverFlowMenuButton">
            <button soho-button="icon"
              id="lm-banner-nav-menu-settings-btn"
              data-automation-id="lm-appmenu-settings-menu-button"
              class="lm-banner-nav-menu-settings-btn"
              soho-tooltip content="{{ 'More' | translate }}"
              [icon]="'more'"
              (click)="toggleActionMenu($event)">
            </button>

            <div #ActionMenu
              id="lm-banner-nav-action-menu"
              data-automation-id="lm-appmenu-settings-menu"
              class="lm-banner-nav-action-menu popupmenu-wrapper bottom"
            >
              <div class="arrow"></div>
              <ul class="popupmenu has-icons">
                <ng-container *ngFor="let button of myOverflowMenuButtons" >
                  <li id="{{button.id}}" (click)="openLink(button.url)" (click)="closeActionMenu()">
                    <a href="javascript:void(0);" role="menuitem" tabindex="-1"
                       attr.data-automation-id="{{button.id}}"
                    >
                      <svg *ngIf="button.icon" soho-icon icon="{{button.icon}}"></svg>
                      {{button.label}}
                    </a>
                  </li>
                </ng-container>
              </ul>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

  </div>

  <div class="application-menu-content">
    <ng-container *ngIf="isPasswordReset">
      <div class="accordion panel inverse">
        <div class="accordion-header"><a><span>{{ 'ResetPassword' | translate }}</span></a></div>
      </div>
    </ng-container>

    <ng-container *ngIf="!isPasswordReset">
    <!-- MENU SEARCH FIELD -->
    <div *ngIf="showSearch && !anonymousUser" soho-searchfield-wrapper>
      <label class="audible" for="application-menu-searchfield">{{ 'Search' | translate }}</label>
      <input id="application-menu-searchfield" soho-toolbar-searchfield
             placeholder="{{ 'Search' | translate }}"
             [(ngModel)]="model.searchFieldValue"
             [collapsibleOnMobile]="true"
             [clearable]="true"
             (ngModelChange)="autoSearchMenu($event)"
             (keydown.enter)="fireMenuSearchEvent($event)"
             (cleared)="fireClearSearchEvent($event)"
      />
    </div>
    <div class="accordion panel inverse" data-options="{'allowOnePane': 'true', 'rerouteOnLinkClick': 'false'}">

      <!--<div class="accordion-pane" id="appmenu_RolesAndApps">-->
      <!--<div class="accordion-header no-icon" *ngFor="let menuItem of webAppMenuSpecs" id="webapp_{{menuItem.webAppName}}">-->
      <!--<a href="#" (click)="onWebAppSelected($event)"-->
      <!--attr.navigationmenuurl="{{menuItem?.navigationMenuUrl || menuItem?.link}}"-->
      <!--title="{{menuItem?.webAppTitle || menuItem?.name}}"-->
      <!--attr.webappname="{{menuItem.webAppName}}">-->
      <!--<span>{{menuItem?.webAppTitle || menuItem?.name}}</span>-->
      <!--</a>-->
      <!--</div>-->
      <!--</div>-->

      <ng-container *ngIf="appSwitcher == 'casual'">
        <ng-container *ngIf="selectedMenuSpec">
          <ng-container *ngIf="webAppMenuSpecs.length === 0 || this.roleSwitcher">
            <lm-banner-menu [bannerMenuSpec]="selectedMenuSpec" (menuLoaded)="onMenuLoaded($event)"></lm-banner-menu>
          </ng-container>
          <ng-container *ngIf="webAppMenuSpecs.length > 0 && !this.roleSwitcher">
            <div #webAppMenuHeader attr.id="{{webAppName}}" class="accordion-header">
              <svg soho-icon icon="user"></svg>
              <a href="#"
                 attr.web-app-name="{{webAppName}}"
                 attr.navigationmenuurl="{{webAppMenuNavigationUrl}}"
                 attr.id="{{webAppName}}"><span>{{webAppTitle || webAppName}}</span>
              </a>
            </div>
            <lm-banner-menu class="accordion-pane has-icons" [bannerMenuSpec]="selectMenuSpec(webAppName) || selectedMenuSpec" (menuLoaded)="onMenuLoaded($event)"></lm-banner-menu>
            <ng-container *ngFor="let menuItem of webAppMenuSpecs">
              <div attr.id="{{menuItem.webAppName}}" class="accordion-header">
                <svg soho-icon icon="folder"></svg>
                <a href="#"
                   attr.web-app-name="{{menuItem.webAppName}}"
                   attr.navigationmenuurl="{{menuItem?.navigationMenuUrl || menuItem?.link}}"
                   title="{{menuItem?.webAppTitle || menuItem?.name}}"
                   attr.id="{{menuItem.webAppName}}"
                ><span>{{menuItem?.webAppTitle || menuItem?.name}}</span></a>
              </div>
              <lm-banner-menu class="accordion-pane has-icons" [bannerMenuSpec]="selectMenuSpec(menuItem.webAppName)" (menuLoaded)="onMenuLoaded($event)"></lm-banner-menu>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
      <div *ngIf="showProxy" class="accordion-header">
        <a (click)="openProxyPage()" href="#" class="hyperlink"><span>{{ 'Proxy' | translate }}</span></a>
      </div>
      <div *ngIf="enableUserContextMenu" class="accordion-header"><a href="#" (click)="openSetUserContextDialog()"><span>{{ 'ActorContextMenuLabel' | translate }}</span></a></div>
      <div *ngIf="createReportUrl" class="accordion-header"><a href="#" (click)="runCreateReport()"><span>{{ 'CreateReport' | translate }}</span></a></div>
      <div *ngIf="allowSetAsOfDate" class="accordion-header"><a href="#" (click)="openSetAsOfDateDialog()"><span>{{ 'AsOfDateLabel' | translate }}</span></a></div>
    </div>
    </ng-container>
  </div>

  <div class="application-menu-footer" [ngClass]="{'lm-do-not-apply-color': !applyColorToMenu }">
    <div class="application-menu-toolbar">
      <div class="flex-toolbar">
        <div class="toolbar-section buttonset">

          <ng-container *ngIf="!anonymousUser && !isPasswordReset">
            <!--
            SETTINGS BUTTON
            -->
            <button *ngIf="!hasChangePasswordLink"
                    soho-button="btn" type="button" id="Settings_button" class="btn l-pull-left"
                    (click)="openUserSettingsDialog()"
                    [icon]="'settings'"
                    soho-tooltip content="{{ 'Settings' | translate }}"
            >{{ 'Settings' | translate }}</button>

            <!--
            CHANGE PASSWORD BUTTON
            -->
            <button *ngIf="hasChangePasswordLink"
                    soho-button="btn" type="button" id="ChangePassword_button" class="btn l-pull-left"
                    (click)="openChangePasswordWindow()"
                    soho-tooltip content="{{ 'ChangePassword' | translate }}"
            >{{ 'ChangePassword' | translate }}</button>

            <!--
            ABOUT BUTTON
            -->
            <button *ngIf="!hasChangePasswordLink"
                    soho-button="icon" type="button" class="btn" id="About_button"
                    soho-tooltip content="{{ 'About' | translate }}"
                    title="{{ 'About' | translate }}"
                    (click)="openLink(aboutLink)"
                    [icon]="'info-linear'"
            >{{ 'About' | translate }}</button>

            <!--
            HELP BUTTON
            -->
            <button *ngIf="appHelpLink && !hasChangePasswordLink"
                    soho-button="icon" type="button" class="btn" id="Help_button"
                    (click)="openHelpLink()"
                    [icon]="'help'"
                    soho-tooltip content="{{ 'Help' | translate }}"
            >{{ 'Help' | translate }}</button>

            <!--
            LOGOUT BUTTON
            -->
            <button *ngIf="!mingleMode"
                    soho-button="icon" type="button" [ngClass]="{'btn l-pull-right' : hasChangePasswordLink }" id="Logout_button"
                    (click)="openSecurityLink(signOutLink)"
                    [icon]="'logout'"
                    soho-tooltip content="{{ 'Logout' | translate }}"
            >{{ 'Logout' | translate }}</button>

          </ng-container>

          <ng-container *ngIf="!anonymousUser && isPasswordReset">
            <!--
            LOGOUT BUTTON
            -->
            <button *ngIf="!mingleMode"
                soho-button="btn" type="button" class="btn l-pull-left" id="Logout_button2"
                (click)="openSecurityLink(signOutLink)"
                [icon]="'logout'"
                soho-tooltip content="{{ 'Logout' | translate }}"
            >{{ 'Logout' | translate }}</button>

          </ng-container>

          <ng-container *ngIf="anonymousUser">

            <!--
            SIGN-IN BUTTON
            -->
            <button *ngIf="clientLogin"
                    soho-button="btn" type="button" class="btn l-pull-left" id="ClientLoginSignIn_button"
                    (click)="openLoginWindow()"
                    soho-tooltip content="{{ 'SignIn' | translate }}"
            >{{ 'SignIn' | translate }}</button>

            <!--
            SIGN-IN BUTTON
            -->
            <button *ngIf="!clientLogin"
                    soho-button="btn" type="button" class="btn l-pull-left" id="SignIn_button"
                    (click)="openSecurityLink(signInLink)"
                    soho-tooltip content="{{ 'SignIn' | translate }}"
            >{{ 'SignIn' | translate }}</button>

            <!--
            REGISTER BUTTON
            -->
            <button *ngIf="hasRegisterLink"
                    soho-button="btn" type="button" class="btn l-pull-right" id="Register_button"
                    (click)="openLink(registerLink)"
                    soho-tooltip content="{{ 'Register' | translate }}"
            >{{ 'Register' | translate }}</button>
          </ng-container>

        </div>
      </div>
    </div>

    <!--<span class="links" *ngIf="anonymousUser">-->
    <!--<a *ngIf="clientLogin" href="#" (click)="openLoginWindow($event)" class="hyperlink">{{ 'SignIn' | translate }}</a>-->
    <!--<a *ngIf="!clientLogin" href="{{signInLink}}" class="hyperlink">{{ 'SignIn' | translate }}</a>-->
    <!--<span *ngIf="hasRegisterLink"> | </span>-->
    <!--<a *ngIf="hasRegisterLink" href="{{registerLink}}" class="hyperlink">{{ 'Register' | translate }}</a>-->
    <!--</span>-->

    <!--<span class="links" *ngIf="!anonymousUser">-->
    <!--&lt;!&ndash;<a *ngIf="proxyManagementLink && !proxyEnabled && !proxyMode" href="{{proxyManagementLink}}" class="hyperlink"><span>{{ 'ProxyManagement' | translate }}</span></a>&ndash;&gt;-->
    <!--&lt;!&ndash;<a *ngIf="proxyEnabled || proxyMode || proxyManagementLink" (click)="openProxyPage($event)" href="#" class="hyperlink"><span>{{ 'Proxy' | translate }}</span></a>&ndash;&gt;-->
    <!--&lt;!&ndash;<a *ngIf="proxyMode || proxyManagementLink" (click)="openResetProxyPage($event)" href="#" class="hyperlink"><span>{{ 'SwitchBackFromProxy' | translate }}</span></a>&ndash;&gt;-->
    <!--&lt;!&ndash;<a href="{{signOutLink}}" class="hyperlink">{{ 'SignOut' | translate }}</a>&ndash;&gt;-->
    <!--<span *ngIf="hasChangePasswordLink"> | </span>-->
    <!--<a *ngIf="hasChangePasswordLink" href="#" (click)="openChangePasswordWindow($event)" class="hyperlink">{{ 'ChangePassword' | translate }}</a>-->
    <!--</span>-->
  </div>

  <!--
    <div class="header-pane" id="appnav_Header">
      <div *ngIf="!mingleMode" class="accordion-content accordion-static-panel logout">
        <svg *ngIf="noActorUrl()" class="icon avatar" viewBox="0 0 48 48" focusable="false" aria-hidden="true" role="presentation">
          <use xlink:href="#icon-user-avatar"></use>
        </svg>
        <img class="icon avatar" *ngIf="!noActorUrl()" [src]="actorUrl">
        <span class="content">
          <span class="name">{{actorName}}</span>

          <span class="links" *ngIf="anonymousUser">
              <a *ngIf="clientLogin" href="#" (click)="openLoginWindow($event)" class="hyperlink">{{ 'SignIn' | translate }}</a>
              <a *ngIf="!clientLogin" href="{{signInLink}}" class="hyperlink">{{ 'SignIn' | translate }}</a>
              <span *ngIf="hasRegisterLink"> | </span>
              <a *ngIf="hasRegisterLink" href="{{registerLink}}" class="hyperlink">{{ 'Register' | translate }}</a>
          </span>

          <span class="links" *ngIf="!anonymousUser">
            <a href="{{signOutLink}}" class="hyperlink">{{ 'SignOut' | translate }}</a>
            <span *ngIf="hasChangePasswordLink"> | </span>
            <a *ngIf="hasChangePasswordLink" href="#" (click)="openChangePasswordWindow($event)" class="hyperlink">{{ 'ChangePassword' | translate }}</a>
          </span>

        </span>

        <ng-container *ngIf="appSwitcher == 'popup'">
          <button soho-menu-button class="btn-menu inverse hide-focus" data-options="{'attachToBody' : 'true', 'isInverse' : 'true', 'replaceText': 'true'}">
            <span>{{webAppTitle}}</span>
          </button>
          <ul soho-popupmenu>
            <li soho-popupmenu-item *ngFor="let menuItem of webAppMenuSpecs">
              <a soho-popup-menu-label
                  id="{{menuItem?.name}}"
                  class="router-link-active"
                  href="javascript:void(0)"
                  (click)="onWebAppSelected($event)"
                  title="{{menuItem?.webAppTitle || menuItem?.name}}"
                  attr.navigationmenuurl="{{menuItem?.navigationMenuUrl || menuItem?.link}}"
              >
                <span>{{menuItem?.webAppTitle || menuItem?.name}}</span>
              </a>
            </li>
          </ul>
        </ng-container>

      </div>
    </div>
  -->

  <!--
    <ng-container *ngIf="appSwitcher == 'all'">
      <div class="accordion-header">
        <svg soho-icon icon="roles"></svg>
        <a href="#"><span>{{ 'MyRoles' | translate }}</span></a>
      </div>
      <lm-banner-menu class="accordion-pane has-icons" [bannerMenuSpec]="bannerMenuSpec" (menuStateRestored)="onMenuStateRestored($event)"></lm-banner-menu>
    </ng-container>


    <ng-container *ngIf="appSwitcher == 'accordion'">
      <div class="accordion-header" id="appnav_WebApps">
        <svg soho-icon icon="roles"></svg>
        <a href="#"><span>{{ 'MyApplications' | translate }}</span></a>
      </div>
      <div class="accordion-pane" id="appmenu_RolesAndApps">
        <div class="accordion-header no-icon" *ngFor="let menuItem of webAppMenuSpecs" id="webapp_{{menuItem.webAppName}}">
          <a href="#" (click)="onWebAppSelected($event)"
              attr.navigationmenuurl="{{menuItem?.navigationMenuUrl || menuItem?.link}}"
              title="{{menuItem?.webAppTitle || menuItem?.name}}"
              attr.webappname="{{menuItem.webAppName}}">
            <span>{{menuItem?.webAppTitle || menuItem?.name}}</span>
          </a>
        </div>
      </div>
      <ng-container *ngIf="selectedMenuSpec">
        <div #webAppMenuHeader id="appnav_AppMenu" class="accordion-header">
          <svg soho-icon icon="user"></svg>
          <a href="#"><span>{{webAppTitle || webAppName}}</span></a>
        </div>
        <lm-banner-menu class="accordion-pane has-icons" [bannerMenuSpec]="selectedMenuSpec" (menuStateRestored)="onMenuStateRestored($event)"></lm-banner-menu>
      </ng-container>
    </ng-container>


    <ng-container *ngIf="appSwitcher == 'suite'">
      <div class="accordion-header"><a href="#" (click)="openLink(webAppSuiteLink)" class="hyperlink"><span>{{applicationsString}}</span></a></div>
      <ng-container *ngIf="webAppMenuSpecs">
        <div #webAppMenuHeader class="accordion-header">
          <svg soho-icon icon="user"></svg>
          <a href="#"><span>{{webAppTitle}}</span></a>
        </div>
        <lm-banner-menu *ngIf="selectedMenuSpec.length > 0" class="accordion-pane has-icons" [bannerMenuSpec]="selectedMenuSpec" (menuStateRestored)="onMenuStateRestored($event)"></lm-banner-menu>
      </ng-container>
    </ng-container>


    <ng-container *ngIf="appSwitcher == 'popup'">
      <lm-banner-menu *ngIf="selectedMenuSpec.length > 0" class="accordion-pane has-icons" [bannerMenuSpec]="selectedMenuSpec" (menuStateRestored)="onMenuStateRestored($event)"></lm-banner-menu>
    </ng-container>
  -->


  <!--
    <ng-container *ngIf="!anonymousUser">
      <div class="accordion-header">
        <svg soho-icon icon="folder"></svg>
        <a href="#"><span>{{ 'MyMenu' | translate }}</span><span id="redDot" [ngClass]="{'red-dot' : displayRedDot }"></span></a>
      </div>
      <div class="accordion-pane">
        <div *ngIf="myNotificationsUrl" class="accordion-header"><a href="#" (click)="openLink(myNotificationsUrl)"><span>{{ 'MyNotifications' | translate }}</span><span id="redDot2" [ngClass]="{'red-dot' : displayRedDot} "></span></a></div>
        <div *ngIf="myInBasketUrl" class="accordion-header"><a href="#" (click)="openLink(myInBasketUrl)"><span>{{ 'MyInbasket' | translate }}</span></a></div>
        <div *ngIf="myJobsUrl" class="accordion-header"><a href="#" (click)="openLink(myJobsUrl)"><span>{{ 'MyJobs' | translate }}</span></a></div>
        <div *ngIf="myPrintFilesUrl" class="accordion-header"><a href="#" (click)="openLink(myPrintFilesUrl)"><span>{{ 'MyPrintFiles' | translate }}</span></a></div>
        <div *ngIf="myActionsUrl" class="accordion-header"><a href="#" (click)="openLink(myActionsUrl)"><span>{{ 'MyActions' | translate }}</span></a></div>
        <div *ngIf="myReportsUrl" class="accordion-header"><a href="#" (click)="openLink(myReportsUrl)"><span>{{ 'MyReports' | translate }}</span></a></div>
        <div class="accordion-header"><a href="#" (click)="runCreateReport()"><span>{{ 'CreateReport' | translate }}</span></a></div>
      </div>
      <ng-container *ngIf="proxyManagementLink || proxyEnabled || proxyMode">
        <div class="accordion-header">
          <svg soho-icon icon="group-selection"></svg>
          <a href="#"><span>{{ 'ProxyMenu' | translate }}</span></a>
        </div>
        <div class="accordion-pane">
          <div *ngIf="proxyManagementLink" class="accordion-header"><a href="{{proxyManagementLink}}" class="hyperlink"><span>{{ 'ProxyManagement' | translate }}</span></a></div>
          <ng-container *ngIf="proxyEnabled">
            <div class="accordion-header">
              <button class="btn" type="button">
                <span class="icon plus-minus" aria-hidden="true" role="presentation"></span>
                <span class="audible">{{ 'Expand' | translate }}</span>
              </button>
              <a href="#" aria-haspopup="true" role="button" aria-expanded="false"><span>{{ 'SwitchToProxy' | translate }}</span></a>
            </div>
            <div class="accordion-pane">
              <ng-container *ngFor="let proxyWebApp of proxyWebApps">
                <div class="accordion-header">
                  <button class="btn" type="button">
                    <span class="audible">{{ 'Expand' | translate }}</span>
                    <span class="icon plus-minus" aria-hidden="true" role="presentation"></span>
                  </button>
                  <a href="#" aria-haspopup="true" role="button" aria-expanded="false"><span>{{proxyWebApp}}</span></a>
                </div>
                <div class="accordion-pane">
                  <div class="accordion-header" *ngFor="let proxyWebAppUser of proxyUserUrls[ proxyWebApp ]">
                    <a href="{{proxyWebAppUser.proxyUserUrl}}" class="hyperlink">{{proxyWebAppUser.proxyUser}}</a>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>
          <ng-container *ngIf="proxyMode">
            <div class="accordion-header">
              <button class="btn" type="button">
                <span class="icon plus-minus" aria-hidden="true" role="presentation"></span>
                <span class="audible">{{expandString}}</span>
              </button>
              <a href="#" aria-haspopup="true" role="button" aria-expanded="false"><span>{{ 'SwitchBackFromProxy' | translate }}</span></a>
            </div>
            <div class="accordion-pane">
              <div class="accordion-header" *ngFor="let proxyResetUrl of proxyResetUrls">
                <a href="#" (click)="onSwitchToProxyClicked(proxyResetUrl.proxyResetWebAppUrl)">{{proxyResetUrl.proxyResetWebApp}}</a>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
      <div *ngIf="allowSetAsOfDate" class="accordion-header"><a href="#" (click)="openSetAsOfDateDialog()"><span>{{ 'AsOfDateLabel' | translate }}</span></a></div>
      <div *ngIf="allowClearAsOfDate" class="accordion-header"><a href="#" (click)="clearAsOfDate()"><span>{{ 'ClearAsOfDateLabel' | translate }}</span></a></div>
      <div *ngIf="enableUserContextMenu" class="accordion-header"><a href="#" (click)="openSetUserContextDialog()"><span>{{ 'ActorContextMenuLabel' | translate }}</span></a></div>
      &lt;!&ndash;<div class="accordion-header">&ndash;&gt;
        &lt;!&ndash;<svg soho-icon icon="folder"></svg>&ndash;&gt;
        &lt;!&ndash;<a href="#"><span>My Reports</span></a>&ndash;&gt;
      &lt;!&ndash;</div>&ndash;&gt;
      &lt;!&ndash;<div class="accordion-pane">&ndash;&gt;
        &lt;!&ndash;<div class="accordion-header" *ngFor="let userFolder of userFolders">&ndash;&gt;
          &lt;!&ndash;<a href="#" (click)="openLink(userFolder.url)">{{userFolder.name}}</a>&ndash;&gt;
        &lt;!&ndash;</div>&ndash;&gt;
      &lt;!&ndash;</div>&ndash;&gt;
      &lt;!&ndash;<div class="accordion-header">&ndash;&gt;
        &lt;!&ndash;<svg soho-icon icon="folder"></svg>&ndash;&gt;
        &lt;!&ndash;<a href="#"><span>Data</span></a>&ndash;&gt;
      &lt;!&ndash;</div>&ndash;&gt;
      &lt;!&ndash;<div class="accordion-pane">&ndash;&gt;
        &lt;!&ndash;<ng-container *ngFor="let dataModule of dataModules">&ndash;&gt;
          &lt;!&ndash;<div class="accordion-header">&ndash;&gt;
            &lt;!&ndash;<button class="btn" type="button">&ndash;&gt;
              &lt;!&ndash;<span class="audible">{{expandString}}</span>&ndash;&gt;
              &lt;!&ndash;<span class="icon plus-minus" aria-hidden="true" role="presentation"></span>&ndash;&gt;
            &lt;!&ndash;</button>&ndash;&gt;
            &lt;!&ndash;<a href="#" aria-haspopup="true" role="button" aria-expanded="false"><span>{{dataModule.moduleName}}</span></a>&ndash;&gt;
          &lt;!&ndash;</div>&ndash;&gt;
          &lt;!&ndash;<div class="accordion-pane">&ndash;&gt;
            &lt;!&ndash;<div class="accordion-header" *ngFor="let busClass of dataModule.busClasses">&ndash;&gt;
              &lt;!&ndash;<a href="{{busClass.primaryListUrl}}" class="hyperlink">{{busClass.busClassName}}</a>&ndash;&gt;
            &lt;!&ndash;</div>&ndash;&gt;
          &lt;!&ndash;</div>&ndash;&gt;
        &lt;!&ndash;</ng-container>&ndash;&gt;
      &lt;!&ndash;</div>&ndash;&gt;
    </ng-container>
  -->


  <!--
    <div class="accordion-header"><a href="#" (click)="openUserSettingsDialog()"><span>{{ 'Settings' | translate }}</span></a></div>
    <div *ngIf="appHelpLink" class="accordion-header"><a href="#" (click)="openHelpLink()"><span>{{ 'Help' | translate }}</span></a></div>
    <div class="accordion-header"><a href="#" (click)="openLink(aboutLink)"><span>{{ 'About' | translate }}</span></a></div>
  </div>
  -->

  <!--
  <div  class="branding">
    <svg soho-icon icon="logo"></svg>
  </div>
  -->
  <div #UserSettingsDialog>
    <!-- dialog placeholder used to display user settings -->
  </div>

  <div #LoginDialog>
    <!-- dialog placeholder used to display login screen -->
  </div>

  <div #AccessDeniedDialog>
    <!-- dialog placeholder used to display access denied error -->
  </div>

  <div #ChangePasswordDialog>
    <!-- dialog placeholder used to display change password screen -->
  </div>

  <div #DrillbackActionFormDialog>
    <!-- dialog placeholder used to display a drillback for an action form -->
  </div>

  <div #ReportPersonalizationDialog>
    <!-- dialog placeholder used to display a report personalization dialog -->
  </div>

  <div #SetAsOfDateDialog>
    <!-- dialog placeholder used to display Set As of Date dialog -->
  </div>

  <div #UserContextDialog>
    <!-- dialog placeholder used to display User Context dialog -->
  </div>


</div>
